import { useEffect, useState } from 'react';
import { trackEvent } from '@/lib/analytics';
import { useScrollDepth } from '@/hooks/useConversionHooks';
import Seo from '@/components/Seo';
import Starfield from '@/components/Starfield';
import { GrainOverlay, CustomCursor, ScrollProgress } from '@/components/Overlays';
import Navbar from '@/components/Navbar';
import IdeaComposer from '@/components/IdeaComposer';
import IdeaFeed from '@/components/IdeaFeed';
import HackerNewsFeed from '@/components/HackerNewsFeed';
import Footer from '@/components/Footer';
import FloatingCTA from '@/components/FloatingCTA';

const Index = () => {
  const [feedKey, setFeedKey] = useState(0);

  useScrollDepth();

  useEffect(() => {
    trackEvent('page_view');
  }, []);

  return (
    <>
      <Seo
        title="Dumbverse — Post an idea, share it everywhere"
        description="Post any idea, however dumb. Upvote and comment on others, then share the best ones straight to X, WhatsApp, LinkedIn, Reddit or Telegram."
        path="/"
      />
      <Starfield />
      <GrainOverlay />
      <CustomCursor />
      <ScrollProgress />
      <Navbar />

      <main>
        {/* Hero + composer */}
        <section className="relative pt-32 pb-12 px-6 overflow-hidden" aria-label="Post an idea">
          <div
            className="absolute inset-0 pointer-events-none"
            style={{ background: 'radial-gradient(circle at 50% 0%, hsl(var(--primary) / 0.18), transparent 65%)' }}
            aria-hidden="true"
          />
          <div className="relative z-10 max-w-3xl mx-auto text-center">
            <p className="font-mono text-xs tracking-[0.3em] uppercase mb-4" style={{ color: 'hsl(var(--orange-light))' }}>
              NO SIGN-UP. NO JUDGEMENT.
            </p>
            <h1 className="font-bebas leading-[0.9] mb-5">
              <span className="block text-6xl md:text-8xl text-foreground">POST YOUR IDEA.</span>
              <span
                className="block text-5xl md:text-7xl text-transparent"
                style={{ WebkitTextStroke: '2px hsl(var(--primary))' }}
              >
                LET THE WORLD SEE IT.
              </span>
            </h1>
            <p className="font-playfair italic text-xl md:text-2xl text-foreground/90 mb-3">
              You'll never know until you post.
            </p>
            <p className="font-mono text-sm text-muted-foreground max-w-xl mx-auto leading-relaxed">
              Drop an idea in one box. Others upvote and comment. Share the good ones anywhere with one tap.
            </p>
          </div>

          <div className="relative z-10 max-w-2xl mx-auto mt-10">
            <IdeaComposer id="post" onPosted={() => setFeedKey(k => k + 1)} />
          </div>
        </section>
        <div id="hero-end" />

        <IdeaFeed key={feedKey} />
        <HackerNewsFeed />
      </main>

      <Footer />
      <FloatingCTA />
    </>
  );
};

export default Index;
